import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import * as redux from '../../redux/CompanyRedux'
import {useHistory, useParams} from 'react-router-dom'

const groupPermissionsByEntity = (permissions: any) => {
  const groupedPermissions: any = {}

  permissions.forEach((permission: any) => {
    const [entity, action] = permission.name.split('.') // Split by "."

    if (!groupedPermissions[entity]) {
      groupedPermissions[entity] = []
    }

    groupedPermissions[entity].push({id: permission.id, action}) // Store action and id
  })

  return groupedPermissions
}
export function EditRole(props: any) {
  const dispatch = useDispatch()
  const history = useHistory()
  const params: any = useParams()
  const permissions: any = useSelector<RootState>(({company}) => company.permissionsList)
  const role: any = useSelector<RootState>(({company}) => company.role)

  const [groupedPermissions, setGroupedPermissions] = useState<any>({})

  useEffect(() => {
    dispatch(redux.actions.getPermissions())
    dispatch(redux.actions.getRole({id: params.id}))
  }, [dispatch, params.id])

  useEffect(() => {
    if (permissions) {
      setGroupedPermissions(groupPermissionsByEntity(permissions))
    }
  }, [permissions])

  const handleSubmit = (values: any, e: any) => {
    e.preventDefault()
    if (values.permissions?.length > 0)
      values.permissions = values.permissions.map((el: any) => el.id)
    dispatch(redux.actions.editRole(values, history))
  }
  return role && role.name ? (
    <>
      <Formik
        onSubmit={(values, {setSubmitting}) => {
          setSubmitting(true)
        }}
        initialValues={{
          id: role ? role.id || null : null,
          name: role ? role.name || '' : '',
          permissions: role ? role.permissions || [] : [],
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Required'),
        })}
      >
        {({
          values,
          touched,
          errors,
          dirty,
          isSubmitting,
          handleChange,
          handleBlur,
          handleReset,
          setSubmitting,
          setFieldValue,
          resetForm,
        }) => (
          <form className='form'>
            <div className='w-100'>
              {/*begin::Heading */}
              {/*begin::Heading */}

              {/*begin::Form Group */}
              <div className='fv-row mb-12 col-3'>
                <label className='fs-6 fw-bolder text-dark form-label'>Role Name</label>
                <input
                  type='text'
                  className='form-control form-control-lg'
                  name='name'
                  value={values.name}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className='bg-white p-5 rounded-3 card-body border-top px-9 pt-3 pb-4'>
              <div className='table-responsive'>
                <table className='table table-row-dashed border-gray-300 align-middle gy-6'>
                  <tbody className='fs-6 fw-bold'>
                    <tr style={{display: 'grid'}}>
                      <td className='min-w-250px fs-4 fw-bolder'>Permissions</td>
                      <td className='w-125px'>
                        {Object.keys(groupedPermissions).map((entity, i) => (
                          <div key={i} className='my-5'>
                            <strong>{entity.charAt(0).toUpperCase() + entity.slice(1)}:</strong>
                            <div className='ml-4'>
                              {groupedPermissions[entity].map((permission: any, j: number) => (
                                <div key={j} className='form-check form-check-solid my-3'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={values.permissions.some(
                                      (perm: any) => perm.id === permission.id
                                    )}
                                    onChange={(event) => {
                                      if (event.target.checked) {
                                        // Add permission if checked
                                        setFieldValue('permissions', [
                                          ...values.permissions,
                                          permission,
                                        ])
                                      } else {
                                        // Remove permission if unchecked
                                        setFieldValue(
                                          'permissions',
                                          values.permissions.filter(
                                            (perm: any) => perm.id !== permission.id
                                          )
                                        )
                                      }
                                    }}
                                  />
                                  <label className='form-check-label ps-2'>
                                    {permission.action}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <button
              className='btn btn-primary'
              style={{backgroundColor: '#87e8c5'}}
              onClick={(e) => {
                setSubmitting(true)
                handleSubmit(values, e)
              }}
              type='submit'
            >
              Submit
            </button>
          </form>
        )}
      </Formik>
    </>
  ) : (
    <></>
  )
}
